import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, User } from 'lucide-react'
import { useAuth } from '../context/AuthContext'

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()
  const { isAuthenticated, isAdmin, logout } = useAuth()

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'Membership', path: '/membership' },
    { name: 'Pool', path: '/pool' },
    { name: 'Tennis', path: '/tennis' },
    { name: 'Facility Reservation', path: '/facility-reservation' },
    { name: 'Events', path: '/events' },
    { name: 'About Us', path: '/about-us' },
    { name: 'Contact', path: '/contact' },
    { name: 'Sponsors', path: '/sponsors' },
    { name: 'Board Minutes', path: '/board-minutes' },
    { name: 'Rules', path: '/rules' },
  ]

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center h-18 py-2">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src="/images/club/picture-977be2d0.jpg"
              alt="Lockridge Forest Swim & Tennis Club"
              className="h-24 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-2 py-2 rounded-md text-xs font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {item.name}
              </Link>
            ))}

            {isAdmin && (
              <Link
                to="/admin"
                className="px-2 py-1.5 ml-3 bg-primary-500 text-white rounded-md text-xs font-medium hover:bg-primary-600 transition-colors"
              >
                Admin
              </Link>
            )}

            {isAuthenticated ? (
              <button
                onClick={logout}
                className="px-2 py-1.5 ml-2 text-gray-700 hover:bg-gray-100 rounded-md text-xs font-medium transition-colors flex items-center gap-1.5"
              >
                <User className="h-4 w-4" />
                Logout
              </button>
            ) : (
              <Link
                to="/login"
                className="px-2 py-1.5 ml-2 text-gray-700 hover:bg-gray-100 rounded-md text-xs font-medium transition-colors flex items-center gap-1.5"
              >
                <User className="h-4 w-4" />
                Login
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="xl:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="xl:hidden pb-3 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {item.name}
              </Link>
            ))}

            {isAdmin && (
              <Link
                to="/admin"
                onClick={() => setIsOpen(false)}
                className="block px-3 py-2 mt-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors"
              >
                Admin
              </Link>
            )}

            {isAuthenticated ? (
              <button
                onClick={() => {
                  logout()
                  setIsOpen(false)
                }}
                className="flex items-center gap-2 w-full text-left px-3 py-2 mt-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium transition-colors"
              >
                <User className="h-4 w-4" />
                Logout
              </button>
            ) : (
              <Link
                to="/login"
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-2 px-3 py-2 mt-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium transition-colors"
              >
                <User className="h-4 w-4" />
                Login
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
